import { render } from "./InvoiceImportExcel.vue?vue&type=template&id=ecec4038&scoped=true"
import script from "./InvoiceImportExcel.vue?vue&type=script&lang=js"
export * from "./InvoiceImportExcel.vue?vue&type=script&lang=js"

import "./InvoiceImportExcel.vue?vue&type=style&index=0&id=ecec4038&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecec4038"]])

export default __exports__